import { AppBar, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import { drawerWidth } from './AppConfig';
import AppToolbar from './AppToolbar';

export type AppBarProps = {
    onMenuButtonClick: React.MouseEventHandler<HTMLButtonElement>
    isMenuOpened: boolean
}

export function AppTopBar ({ isMenuOpened, onMenuButtonClick }: AppBarProps) {
    const cls = useStyles();

    return (
        <AppBar 
            position="fixed"
            className={clsx(cls.appBar, {
                [cls.appBarShift]: isMenuOpened,
            })}        
        >
            <AppToolbar 
                isMenuOpened={isMenuOpened}
                onMenuButtonClick={onMenuButtonClick}
            />
        </AppBar>
    )
}

const useStyles = makeStyles(theme => ({
    appBar: {
        transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
        }),
    },
    
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
        }),
    }
}));